import { useMemo } from "react";
import type {
  MediaMetadata,
  PlatformRequirements,
} from "../components/brandDetails/tabs/creator-studio/platforms/types";

const REQUIREMENTS: PlatformRequirements = {
  maxImages: 1,
  maxVideos: 0,
  imageFormats: "JPEG, PNG, GIF",
  videoFormats: "Not supported via API",
  maxImageSize: "20 MB",
  maxVideoSize: "N/A",
  videoDuration: "N/A",
  recommended: "1200 × 628 px",
  minDimensions: "No strict limit",
  maxDimensions: "No strict limit",
  aspectRatios: "Flexible (16:9, 4:3, 1:1, 9:16)",
  note: "Video posts not supported via API",
};

export interface RedditFormValidation {
  imageCountValid: boolean | null;
  imageSizeValid: boolean | null;
}

export function useRedditForm(mediaMetadata: MediaMetadata[]) {
  const maxImages =
    typeof REQUIREMENTS.maxImages === "number" ? REQUIREMENTS.maxImages : 1;

  const validation = useMemo((): RedditFormValidation => {
    const enabledMedia = mediaMetadata.slice(0, maxImages);

    if (enabledMedia.length === 0) {
      return {
        imageCountValid: null,
        imageSizeValid: null,
      };
    }

    const images = enabledMedia.filter((m) => m.type === "image");

    const imageCountValid =
      images.length === 0 ? null : images.length <= maxImages;

    const maxImageSizeBytes = 20 * 1024 * 1024;
    const imageSizeValid =
      images.length === 0
        ? null
        : images.every((img) => img.size <= maxImageSizeBytes);

    return {
      imageCountValid,
      imageSizeValid,
    };
  }, [mediaMetadata, maxImages]);

  return { validation, requirements: REQUIREMENTS };
}
